import Classnames from 'classnames';
import { map, get } from 'lodash';
import PropTypes from 'prop-types';
import React from 'react';

import { Sub, SubBold } from 'components/Sub';
import Theme from 'styles/theme';

const CollectionSecondaryNavigationDesktop = ({ secondaryNavigationOptions, trackNavigation }) => (
  <ul className="CollectionSecondaryNavigationDesktop">
    {map(secondaryNavigationOptions, (option, index) => {
      const optionLabel = get(option, 'label');
      const optionLink = get(option, 'linkUrl');

      return (
        <li
          className={Classnames('CollectionSecondaryNavigationDesktop__list-item', {
            'CollectionSecondaryNavigationDesktop__list-item--active': get(option, 'isActive'),
            'CollectionSecondaryNavigationDesktop__list-item--inactive': !get(option, 'isActive'),
          })}
          key={index}
        >
          {get(option, 'isActive') ? (
            <SubBold>{optionLabel}</SubBold>
          ) : (
            <Sub>
              <a
                key={optionLabel}
                href={optionLink}
                onClick={() => trackNavigation(optionLink)}
                className="CollectionSecondaryNavigationDesktop__list-item-link"
              >
                {optionLabel}
              </a>
            </Sub>
          )}
        </li>
      );
    })}
    <style jsx>
      {`
        .CollectionSecondaryNavigationDesktop {
          list-style: none;
          padding: 0;
          margin: 0;
        }

        .CollectionSecondaryNavigationDesktop__list-item:not(:first-child) {
          padding-top: ${Theme.get('spacing') * 2}px;
        }

        .CollectionSecondaryNavigationDesktop__list-item-link {
          text-decoration: none;
          color: ${Theme.get('colors-black')};
          font-size: inherit;
        }

        .CollectionSecondaryNavigationDesktop__list-item-link:hover {
          text-decoration: underline;
        }
      `}
    </style>
  </ul>
);

CollectionSecondaryNavigationDesktop.propTypes = {
  secondaryNavigationOptions: PropTypes.arrayOf(
    PropTypes.shape({
      linkUrl: PropTypes.string.isRequired,
      label: PropTypes.string.isRequired,
      isActive: PropTypes.bool.isRequired,
    })
  ).isRequired,
  trackNavigation: PropTypes.func.isRequired,
};

export default CollectionSecondaryNavigationDesktop;
